import useApi from '../utils/axios-pettitions';
import { useAppSelector } from '../contexts/hooks';
import { newToast } from '../components';
import { formatMessage } from 'devextreme/localization';
import { ResultEstadoResult, ResultFilterRequest, SendResultByEmail, SendResultByWhatsApp } from '../types/types.orders';

export const UseApiResults = () => {
  const { runApi, runApiFormData } = useApi();
  const idOrd = useAppSelector((x) => x.globalOrders.CurrentOrder.IdOrder);

  ///Obtiene los resultados de una orden especifica
  // signal permite abortar una consulta en vuelo cuando el grid de resultados va a
  // pedir otra (cambio de orden o de filtros): la respuesta vieja se descartaría igual.
  const getResults = async (idOrdDb?: number, data?: ResultFilterRequest, signal?: AbortSignal) => {
    let id;
    if (idOrd && idOrd !== -1 && !idOrdDb) {
      id = idOrd;
    } else if (idOrdDb && idOrdDb !== -1) {
      id = idOrdDb;
    } else {
      newToast('ERROR', formatMessage('No se ha seleccionado una orden'), 5);
      return [];
    }
    const params: any = { idOrden: id };
    const resp = await runApi('Results/getResults', 'POST', params, data, undefined, signal);
    if (resp.internalCode === 105) {
      return resp.data;
    }
    return [];
  };

  const uploadDxImage = async (formData: FormData) => {
    const res = await runApiFormData('Results/uploadDxImage', formData);

    if (res.internalCode >= 200) {
      newToast('ERROR', res.message, 3);
    } else {
      newToast('SUCCESS', res.message, 3);
      return res.data;
    }
  };

  const getDxImageUrl = async (fileName: string) => {
    const resp = await runApi('Results/GetDxImageUrl', 'GET', { fileName }, null);
    if (resp.internalCode === 105) {
      return resp.data?.Url || resp.data;
    }
    return '';
  };

  const deleteDxImage = async (fileName: string) => {
    const resp = await runApi('Results/DeleteDxImage', 'POST', { fileName }, null);    
    if (resp.internalCode === 108) {
      newToast('SUCCESS', resp.message, 3);
      return true;
    }
    newToast('ERROR', resp.message, 3);
    return false;
  };

  const getResultsForValMasive = async (StartDate?: Date, EndDate?: Date, data?: ResultFilterRequest) => {
    const params: any = { StartDate, EndDate };
    const resp = await runApi('Results/getResultsForValMasive', 'POST', params, data);
    if (resp.internalCode === 105) {
      return resp.data;
    }
    return [];
  };

  ///Elimina o pone un resultado para una plantilla, usado para clarear resultados o poner resultados masivamente, Ejemplo: Poner el resultado ADJUNTO a un resultado adjunto.
  const getResultImage = async (IdRes: number) => {
    if (!idOrd || idOrd === -1) {
      return false;
    }
    const resp = await runApi('Results/GetResultImage', 'GET', { IdRes }, null);
    if (resp.internalCode === 101) {
      return resp.data;
    }
    return null;
  };

  const getHistoryPatient = async (IdPc: number, IdAn: number) => {
    if (!idOrd || idOrd === -1) {
      return false;
    }
    const resp = await runApi('Results/getPatientHistory', 'GET', { idPc: IdPc, idAn: IdAn }, null);
    if (resp.internalCode === 101) {
      return resp.data;
    }
    return null;
  };

  ///Elimina o pone un resultado para una plantilla, usado para clarear resultados o poner resultados masivamente, Ejemplo: Poner el resultado ADJUNTO a un resultado adjunto.
  const putInValidationNote = async (IdRes: number, Note: string) => {
    if (!idOrd || idOrd === -1) {
      return false;
    }
    const resp = await runApi('Results/PutValidationNote', 'POST', { IdRes, Note }, null);
    if (resp.internalCode === 105) {
      return resp.data;
    }
    return null;
  };

  ///Elimina o pone un resultado masivamente, usado para clarear resultados o poner resultados masivamente, Ejemplo: Poner el resultado ADJUNTO a un resultado adjunto.
  const putResult = async ({ keys, Result }: { keys: any[]; Result?: string }) => {
    if (!keys || keys.length === 0) {
      return false;
    }
    if (!idOrd || idOrd === -1) {
      return false;
    }
    const resp = await runApi('Results/putResults', 'POST', null, { Result: Result, LstIdRes: keys });
    if (resp.internalCode === 105) {
      return true;
    }
    return false;
  };

  ///Elimina o pone un resultado para una plantilla, usado para clarear resultados o poner resultados masivamente, Ejemplo: Poner el resultado ADJUNTO a un resultado adjunto.
  const putResultImage = async ({ keys, Result }: { keys: any[]; Result?: string }) => {
    if (!keys || keys.length === 0) {
      return false;
    }
    if (!idOrd || idOrd === -1) {
      return false;
    }
    const resp = await runApi('Results/PutResultsImage', 'POST', null, { Result: Result, LstIdRes: keys });
    if (resp.internalCode === 105) {
      return true;
    }
    return false;
  };

  ///Elimina o pone un resultado para una imagen, usado para clarear resultados o poner resultados masivamente, Ejemplo: Poner el resultado ADJUNTO a un resultado adjunto.
  const putResultTemplate = async ({ keys, Result, ResultTemp }: { keys: any[]; Result?: string; ResultTemp?: string }) => {
    if (!keys || keys.length === 0) {
      return false;
    }
    if (!idOrd || idOrd === -1) {
      return false;
    }
    const resp = await runApi('Results/putResultsTemplate', 'POST', null, { Result: Result, Result2: ResultTemp, LstIdRes: keys });
    if (resp.internalCode === 105) {
      return true;
    }
    return false;
  };

  ///Realiza la validación masiva de resultados o pone en resultados en blanco
  const deleteAnalitoResult = async ({ IdEs, IdAn }: { IdEs: number; IdAn: number }) => {
    if (!idOrd || idOrd === -1) {
      return false;
    }
    const resp = await runApi('Results/deleteAnalitoResult', 'POST', { IdOrd: idOrd, IdEs, IdAn }, null);
    if (resp.internalCode === 108) {
      newToast('SUCCESS', resp.message, 5);
      return true;
    }
    newToast('ERROR', resp.message, 5);
    return false;
  };

  const validateResult = async ({ keys, action }: { keys: any[]; action: ResultEstadoResult }) => {
    if (!keys || keys.length === 0) {
      return false;
    }
    const resp = await runApi('Results/putValidateResults', 'POST', null, { NewState: action, LstIdRes: keys });
    if (resp.internalCode === 105) {
      return true;
    }
    return false;
  };

  ///Realiza la validación masiva de resultados o pone en resultados en blanco
  const putPrintResult = async ({ keys }: { keys: number[] }) => {
    if (!idOrd || idOrd === -1) {
      return false;
    }
    const resp = await runApi('Results/putPrintResults', 'POST', null, { LstIdRes: keys, IdOrd: idOrd });
    if (resp.internalCode === 105) {
      return true;
    }
    return false;
  };

  ///Realiza la validación masiva de resultados o pone en resultados en blanco
  const putPrintResultFromSearch = async (idOrder: number, keys: number[]) => {
    if (!idOrder || idOrder === -1) {
      return false;
    }
    const resp = await runApi('Results/putPrintResults', 'POST', null, { LstIdRes: keys, IdOrd: idOrder });
    if (resp.internalCode === 105) {
      return true;
    }
    return false;
  };

  /**
   * Registra la impresión de VARIAS órdenes a la vez (impresión masiva).
   *
   * El endpoint de una sola orden no sirve aquí: la impresión masiva imprime un lote completo y
   * hay que marcar como impresas todas las órdenes, no una. El backend lo resuelve en una sola
   * transacción, así que o quedan registradas todas o ninguna.
   */
  const putPrintResultsMasive = async (orders: number[], studies?: number[]) => {
    if (!orders || orders.length === 0) {
      return false;
    }
    const resp = await runApi('Results/putPrintResultsMasive', 'POST', null, { LstIdOrd: orders, LstIdEs: studies ?? [] });
    return resp.internalCode === 105;
  };

  const inValidateResult = async ({ keys, note }: { keys: any[]; note: string }) => {
    if (!keys || keys.length === 0) {
      return false;
    }
    if (!idOrd || idOrd === -1) {
      return false;
    }
    const resp = await runApi('Results/putInValidateResults', 'POST', null, { DesvalidationNote: note, LstIdRes: keys });
    if (resp.internalCode === 105) {
      return true;
    }
    return false;
  };

  //Retransmite un resultado a fuentes externas
  const reSendResults = async ({ keys }: { keys: any[]; Result?: string }) => {
    if (!keys || keys.length === 0) {
      return false;
    }
    if (!idOrd || idOrd === -1) {
      return false;
    }
    const resp = await runApi('Results/putResendResults', 'POST', null, { LstIdRes: keys });
    if (resp.internalCode === 105) {
      return true;
    }
    return false;
  };

  //Retransmite un resultado a fuentes externas
  const senResultByMail = async (data: SendResultByEmail) => {
    const resp = await runApi('Results/setResultByEmail', 'POST', null, data);
    if (resp.internalCode === 101) {
      newToast('SUCCESS', 'El correo fué enviado correctamente', 5);
      return true;
    }
    return false;
  };

  //Envía resultados masivos por correo
  const senResultByMailMasive = async (data: any) => {
    const resp = await runApi('Results/setResultByEmailFromMasive', 'POST', null, data);
    if (resp.internalCode === 110) {
      newToast('SUCCESS', 'Los correos fueron enviados correctamente', 5);
      return true;
    }
    return false;
  };

  //Envía resultados por WhatsApp
  const senResultByWhatsApp = async (data: SendResultByWhatsApp) => {
    const resp = await runApi('Results/setResultByWhatsApp', 'POST', null, data);
    if (resp.internalCode === 110) {
      newToast('SUCCESS', resp.message, 5);
      return true;
    }
    return false;
  };

  //Obtiene el historial de conversaciones de WhatsApp para un paciente
  const getConversationWhatsApp = async (idOrd: number) => {
    const resp = await runApi('Results/getConversationWhatsApp', 'GET', { idOrd }, null);
    if (resp.internalCode === 110) {
      return resp.data || [];
    }
    return [];
  };

  //Envia resultados masivos por WhatsApp
  const sendResultMasiveByWhatsApp = async () => {
    const resp = await runApi('Results/sendResultMasiveByWhatsApp', 'POST', null, null);
    if (resp.internalCode <= 199) {
      return resp;
    }
    newToast('ERROR', resp.message, 5);
    return null;
  };

  //Envia resultados masivos para remisiones externas
  const sendResultMasiveExternalRemission = async () => {
    const resp = await runApi('Results/sendResultMasiveExternalRemission', 'POST', null, null);
    if (resp.internalCode <= 199) {
      return resp;
    }
    newToast('ERROR', resp.message, 5);
    return null;
  };

  //Envia resultados masivos por correo
  const sendResultMasiveByEmail = async () => {
    const resp = await runApi('Results/sendResultMasiveByEmail', 'POST', null, null);
    if (resp.internalCode <= 199) {
      return resp;
    }
    newToast('ERROR', resp.message, 5);
    return null;
  };

  const getEstudiesByOrder = async (idOrd: number) => {
    if (!idOrd || idOrd === -1) {
      return false;
    }
    const resp = await runApi('Results/GetEstudiesByOrder', 'GET', { idOrd }, null);
    if (resp.internalCode === 101) {
      return resp.data;
    }
    return null;
  };

  return {
    deleteAnalitoResult,
    putPrintResult,
    uploadDxImage,
    getDxImageUrl,
    deleteDxImage,
    putPrintResultFromSearch,
    putPrintResultsMasive,
    reSendResults,
    putResult,
    putResultTemplate,
    validateResult,
    inValidateResult,
    putResultImage,
    getResultImage,
    putInValidationNote,
    getHistoryPatient,
    getResults,
    getResultsForValMasive,
    senResultByMail,
    senResultByMailMasive,
    senResultByWhatsApp,
    getConversationWhatsApp,
    getEstudiesByOrder,
    sendResultMasiveByWhatsApp,
    sendResultMasiveExternalRemission,
    sendResultMasiveByEmail,
  };
};
